import React, {Component} from "react";
import {Layout, Table, Modal, Form, Input, Pagination, Button, Select, message} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './manage.less'
import '../../assets/css/admin.less'
import {
    reqAddDepartment,
    reqAddGrade, reqAddSpeciality,
    reqDepartmentList, reqEditDepartment, reqEditGrade, reqEditSpeciality,
    reqGradeList,
    reqSpecialtyList
} from "../../api";

const {Content} = Layout;

/**
 * 配置管理路由组件
 */
class Manage extends Component {

    state = {
        specialityTotal:0,
        specialityPage:1,
        departmentTotal: 0,
        departmentPage: 1,
        gradeTotal: 0,
        gradePage: 1,
        size: 10,
        specialtyList: [],
        gradeList: [],
        departmentList: [],
        ModalText: '',
        visible: false,
        specialtyName: '',
        departmentName: '',
        gradeName: '',
        confirmLoading: false,
        config:{}
    };

    getSpecialtyList = async (data) => {
        const result = await reqSpecialtyList(data);
        if (result.code === '000000') {
            this.setState({
                specialtyList: result.data.rows,
                specialityTotal: result.data.total,
                specialityPage: result.data.page
            })
        } else {
            message.error(result.msg);
        }
    };

    getGradeList = async (data) => {
        const result = await reqGradeList(data);
        if (result.code === '000000') {
            this.setState({
                gradeList: result.data.rows,
                gradeTotal: result.data.total,
                gradePage: result.data.page
            })
        } else {
            message.error(result.msg);
        }
    };

    getDepartmentList = async (data) => {
        const result = await reqDepartmentList(data);
        if (result.code === '000000') {
            this.setState({
                departmentList: result.data.rows,
                departmentTotal: result.data.total,
                departmentPage: result.data.page
            })
        } else {
            message.error(result.msg);
        }
    };

    gradePageClick = async page => {
        let data = {
            page: page,
            size: 10
        };
        this.getGradeList(data)
    };

    departmentPageClick = async page => {
        let data = {
            page: page,
            size: 10
        };
        this.getDepartmentList(data)
    };

    specialityPageClick = async page => {
        let data = {
            page: page,
            size: 10
        };
        this.getSpecialtyList(data)
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total) => {
        return '共' + total + '条记录/每页' + this.state.size + '条';
    };

    showAddGradeModal = () => {
        this.setState({
            visible: true,
            ModalText: '添加年级',
            config:{}
        });
    };

    showAddDepartmentModal = () => {
        this.setState({
            visible: true,
            ModalText: '添加院/系',
            config:{}
        });
    };

    showAddSpecialityModal = () => {
        this.setState({
            visible: true,
            ModalText: '添加专业',
            config:{}
        });
    };

    showEditGradeModal = (record) => {
        const config = {
            id: record.id,
            name: record.name,
        };

        this.setState({
            visible: true,
            ModalText: '编辑年级信息',
            config: config
        });
    };

    showEditDepartmentModal = (record) => {
        const config = {
            id: record.id,
            name: record.name,
        };

        this.setState({
            visible: true,
            ModalText: '编辑院/系信息',
            config: config
        });
    };

    showEditSpecialityModal = (record) => {
        const config = {
            id: record.id,
            name: record.name,
        };

        this.setState({
            visible: true,
            ModalText: '编辑专业信息',
            config: config
        });
    };

    handleOk = (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                switch (this.state.ModalText) {
                    case "添加年级":
                        let addGrade = new FormData();
                        addGrade.append("name", values["name"]);
                        const addGradeResult = await reqAddGrade(addGrade);
                        if(addGradeResult.code === '000000') {
                            this.getGradeList({
                                page: 1,
                                size: 10
                            });
                            message.success("添加成功");
                            this.setState({
                                visible: false,
                                confirmLoading: false,
                            });
                        }else {
                            message.error(addGradeResult.data.msg);
                        }
                        break;
                    case "添加院/系":
                        let addDepartment = new FormData();
                        addDepartment.append("name", values["name"]);
                        const addDepartmentResult = await reqAddDepartment(addDepartment);
                        if(addDepartmentResult.code === '000000') {
                            this.getDepartmentList({
                                page: 1,
                                size: 10
                            });
                            message.success("添加成功");
                            this.setState({
                                visible: false,
                                confirmLoading: false,
                            });
                        }else {
                            message.error(addDepartmentResult.data.msg);
                        }
                        break;
                    case "添加专业":
                        let addSpeciality = new FormData();
                        addSpeciality.append("name", values["name"]);
                        const addSpecialityResult = await reqAddSpeciality(addSpeciality);
                        if(addSpecialityResult.code === '000000') {
                            this.getSpecialtyList({
                                page: 1,
                                size: 10
                            });
                            message.success("添加成功");
                            this.setState({
                                visible: false,
                                confirmLoading: false,
                            });
                        }else {
                            message.error(addSpecialityResult.data.msg);
                        }
                        break;
                    case "编辑专业信息":
                        let editSpeciality = new FormData();
                        editSpeciality.append("name", values["name"]);
                        const editSpecialityResult = await reqEditSpeciality(values.did,editSpeciality);
                        if(editSpecialityResult.code === '000000') {
                            this.getSpecialtyList({
                                page: 1,
                                size: 10
                            });
                            message.success("编辑成功");
                            this.setState({
                                visible: false,
                                confirmLoading: false,
                            });
                        }else {
                            message.error(editSpecialityResult.data.msg);
                        }
                        break;
                    case "编辑院/系信息":
                        let editDepartment = new FormData();
                        editDepartment.append("name", values["name"]);
                        const editeditDepartmentResult = await reqEditDepartment(values.did,editDepartment);
                        if(editeditDepartmentResult.code === '000000') {
                            this.getDepartmentList({
                                page: 1,
                                size: 10
                            });
                            message.success("编辑成功");
                            this.setState({
                                visible: false,
                                confirmLoading: false,
                            });
                        }else {
                            message.error(editeditDepartmentResult.data.msg);
                        }
                        break;
                    case "编辑年级信息":
                        let editGrade = new FormData();
                        editGrade.append("name", values["name"]);
                        const editGradeResult = await reqEditGrade(values.did,editGrade);
                        if(editGradeResult.code === '000000') {
                            this.getGradeList({
                                page: 1,
                                size: 10
                            });
                            message.success("编辑成功");
                            this.setState({
                                visible: false,
                                confirmLoading: false,
                            });
                        }else {
                            message.error(editGradeResult.data.msg);
                        }
                        break;
                }
            }
        });

    };
    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };
    componentDidMount = async () => {
        this.getSpecialtyList({
            page: 1,
            size: 10
        });
        this.getGradeList({
            page: 1,
            size: 10,
        });
        this.getDepartmentList({
            page: 1,
            size: 10,
        });
        document.getElementsByClassName("ant-menu-item")[11].click();
    };

    render() {

        const {getFieldDecorator} = this.props.form;

        const {gradePage,gradeTotal,specialityTotal,specialityPage,departmentTotal,departmentPage, size, confirmLoading, departmentList, specialtyList, gradeList, ModalText, visible} = this.state;
        const gradeColumns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                width:550
            },
            {
                title: '年级',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '操作',
                key: 'action',
                width:150,
                render: (text, record) => (
                    <span>
                    <a onClick={this.showEditGradeModal.bind(this, record)}>编辑</a>
                </span>
                ),
            },
        ];
        const departmentColumns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                width:550
            },
            {
                title: '院/系',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '操作',
                key: 'action',
                width:150,
                render: (text, record) => (
                    <span>
                    <a onClick={this.showEditDepartmentModal.bind(this, record)}>编辑</a>
                </span>
                ),
            },
        ];
        const specialityColumns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                width:550
            },
            {
                title: '专业',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '操作',
                key: 'action',
                width:150,
                render: (text, record) => (
                    <span>
                    <a onClick={this.showEditSpecialityModal.bind(this, record)}>编辑</a>
                </span>
                ),
            },
        ];
        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right grade'>
                            <div className='table_search'>
                                <Button className='add_class' onClick={this.showAddGradeModal}>新建年级</Button>
                                <Button className='add_class' onClick={this.showAddDepartmentModal}>新建院系</Button>
                                <Button className='add_class' onClick={this.showAddSpecialityModal}>新建专业</Button>
                            </div>
                            <Table  columns={gradeColumns} pagination={false}
                                    dataSource={gradeList} rowKey={gradeList => gradeList.id}/>
                            <Pagination total={gradeTotal} current={gradePage} pageSize={size} onChange={this.gradePageClick}
                                        itemRender={this.itemRender} showTotal={this.showTotal}/>

                            <Table  columns={departmentColumns} pagination={false}
                                    dataSource={departmentList} rowKey={departmentList => departmentList.id}/>
                            <Pagination total={departmentTotal} current={departmentPage} pageSize={size} onChange={this.departmentPageClick}
                                        itemRender={this.itemRender} showTotal={this.showTotal}/>

                            <Table  columns={specialityColumns} pagination={false}
                                    dataSource={specialtyList} rowKey={specialtyList => specialtyList.id}/>
                            <Pagination total={specialityTotal} current={specialityPage} pageSize={size} onChange={this.specialityPageClick}
                                        itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <Modal className='grade_modal' title={ModalText} visible={visible} onOk={this.handleOk}
                               confirmLoading={confirmLoading} onCancel={this.handleCancel}
                               okText="确认" cancelText="取消" destroyOnClose='true'>
                           <Form>
                               <Form.Item hidden>
                                   {getFieldDecorator('did', {
                                       initialValue: this.state.config.id,
                                   })(<Input hidden/>)}
                               </Form.Item>
                               <Form.Item label='名称'>
                                   {getFieldDecorator('name', {
                                       rules: [{required: true, message: '请输入新增名称!'}],
                                       initialValue: this.state.config.name
                                   })(
                                       <Input className='input' placeholder='请输入新增名称'/>,
                                   )}
                               </Form.Item>
                            </Form>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}


const WrapManage = Form.create()(Manage);
export default WrapManage;